import api from "./api";

const SchengenService = {
  async save(data) {
    const r = await api.post("/schengen", data);
    return r.data;
  },
  async list(email) {
    const r = await api.get("/schengen", { params: { email } });
    return r.data;
  },
  async getByTrackId(trackId) {
    const r = await api.get(`/schengen/${trackId}`);
    return r.data;
  },
  async remove(trackId) {
    const r = await api.delete(`/schengen/${trackId}`);
    return r.data;
  },
};

export default SchengenService;
